export default __webpack_public_path__ + "static/media/Member_HsiangChihLo.ffbdeda5.jpg";